import React from 'react';
import { Sparkles } from 'lucide-react';
import { EField, FieldRow } from './EditableField';

export default function SectionFooter({
  brand_name = '', brand_tagline = '', link_columns = [], copyright = '',
  mode = 'view', onChange,
}) {
  const set = (k) => (v) => onChange?.({ [k]: v });
  const updCol = (i, k, v) => onChange?.({ link_columns: link_columns.map((c, idx) => idx === i ? { ...c, [k]: v } : c) });
  const updLink = (ci, li, v) => onChange?.({ link_columns: link_columns.map((c, idx) => idx === ci ? { ...c, links: c.links.map((l, lx) => lx === li ? v : l) } : c) });
  const addCol = () => onChange?.({ link_columns: [...link_columns, { title: 'New', links: ['Item'] }] });
  const remCol = (i) => onChange?.({ link_columns: link_columns.filter((_, idx) => idx !== i) });
  const addLink = (ci) => onChange?.({ link_columns: link_columns.map((c, idx) => idx === ci ? { ...c, links: [...c.links, 'New link'] } : c) });
  return (
    <footer className="bg-ee-bg2 border-t border-ee-border py-16">
      <div className="ee-container grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-full border border-gold/40 bg-gold/10 flex items-center justify-center"><Sparkles size={18} className="text-gold" /></div>
            <div className="font-serif text-white text-lg"><EField value={brand_name} onChange={set('brand_name')} mode={mode} /></div>
          </div>
          <p className="text-sm text-ee-muted leading-relaxed"><EField multiline value={brand_tagline} onChange={set('brand_tagline')} mode={mode} /></p>
        </div>
        {link_columns.map((col, ci) => (
          <div key={ci}>
            <div className="text-white font-medium mb-4 text-sm uppercase tracking-wider">
              <EField value={col.title} onChange={(v) => updCol(ci, 'title', v)} mode={mode} />
              {mode === 'edit' && <button onClick={() => remCol(ci)} className="ml-2 text-xs text-red-400">x</button>}
            </div>
            <ul className="space-y-2">
              {col.links?.map((l, li) => (
                <li key={li} className="text-sm text-ee-text2 hover:text-gold transition-colors cursor-pointer">
                  <EField value={l} onChange={(v) => updLink(ci, li, v)} mode={mode} />
                </li>
              ))}
              {mode === 'edit' && <li><button onClick={() => addLink(ci)} className="text-xs text-gold">+ link</button></li>}
            </ul>
          </div>
        ))}
        {mode === 'edit' && <button onClick={addCol} className="self-start text-xs px-3 py-1.5 rounded border border-gold/40 text-gold">+ Column</button>}
      </div>
      <div className="ee-container mt-10 pt-6 border-t border-ee-border text-xs text-ee-dim text-center">
        <EField value={copyright} onChange={set('copyright')} mode={mode} />
      </div>
    </footer>
  );
}
